import React, { useMemo, useState } from 'react'
import { toastGenerator } from "../../utils/helper";
import { Button, Thead, Tbody, Tr, Td, Input, Flex, Text, useToast, Box, IconButton, AlertDialog, AlertDialogBody, AlertDialogContent, AlertDialogFooter, AlertDialogHeader, AlertDialogOverlay, HStack, useDisclosure, Tooltip } from "@chakra-ui/react";
import { Table} from "@chakra-ui/react";
import { TiDelete } from "react-icons/all";
import { Spinner } from "../Loader";
import "./NationalTable.css";
import { invalidateTouristNationalityQuery, useAddTouristNationality, useDeleteTouristNationality } from '../../utils/hooks/touristNationality';

function NationalTouristTable({payroll, filter, bonus, isAllowAdd, isAllowRevert, payrollApprovals}) {
    const [selected, setSelected] = useState([]);
    const toast = useToast();
    const { isOpen: isDeleteModalOpen, onOpen: onDeleteModalOpen, onClose: onDeleteModalClose } = useDisclosure();
    const [/* exchangeRateOfTax */ , setExchangeRateOfTax] = useState(0)
    const [/* exchangeRateOfStatePension */ , setExchangeRateOfStatePension] = useState(0)

    // //Number formatter
    // let formatter = new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

    const addPayroll = useAddTouristNationality({
		onSuccess(data) {
			if (data) {
				toast(toastGenerator({ status: data.body.status ? "success" : "warning", message: data.body.message }));
				if (data.body.status) {
                    invalidateTouristNationalityQuery();
				}
			}
		},
		onError() {
			toast(toastGenerator({ status: "error" }));
		},
	});

    const deletePayrollMutation = useDeleteTouristNationality({
		onSuccess(data) {
			if (data) {
				toast(toastGenerator({ status: data.body.status ? "success" : "warning", message: data.body.message }));
				if (data.body.status) {
					invalidateTouristNationalityQuery();
					onDeleteModalClose();
				}
			}
		},
	});


  
    useMemo(() => {
        if(payrollApprovals?.isSubmitted === 1) {
            payroll.data.forEach((val, i) => {
                if( i === 0) {
                    setExchangeRateOfTax(val.employeePayrollResponses[0].exchangeRateOfTax);
                    setExchangeRateOfStatePension(val.employeePayrollResponses[0].exchangeRateOfStatePension);
                }
                             
            })
        }

    }, [payrollApprovals, payroll.data])

    const onPayrollSave = (employee) => {
        let jsonData = [];
        employee.forEach((val)=>{
            val.status === 1 &&
                jsonData.push({
                    companyId: filter.companyId?.value,
                    employeeId: val.employeeId,              
                })
        })
        addPayroll.mutate(jsonData);    
    }


    

    
  return (
    <>
    <AlertDialog motionPreset="slideInBottom" isOpen={isDeleteModalOpen} isCentered>
        <AlertDialogOverlay />

        <AlertDialogContent>
            <AlertDialogHeader fontSize="lg">Confirmation</AlertDialogHeader>

            <AlertDialogBody>
                {`Are you sure you want to revert ${selected.length > 1 ? "these payrolls?" : "this payroll?" }`}
            </AlertDialogBody>
            <AlertDialogFooter>
                <HStack spacing="2">
                    <Button onClick={onDeleteModalClose}>No</Button>
                    <Button
                        colorScheme="red"
                        isLoading={deletePayrollMutation.isLoading}
                        onClick={() => {
                            deletePayrollMutation.mutate(selected); 
                        }}
                    >
                        Yes
                    </Button>
                </HStack>
            </AlertDialogFooter>
        </AlertDialogContent>
    </AlertDialog>
    
    {addPayroll.isLoading &&
        <Box zIndex={1000}>
            <Spinner/> 
        </Box>
    }
       
    <Box style={{ position: "sticky", left: "0"}} w="100%" mb="10px">
        <Text textAlign="center" fontSize="25px" fontWeight="bold">Nationality Tourist Buying Ticket to Angkor</Text>
    </Box>

    <Table w={ filter.payrunSchedule === 2 ? "300px" : "2200px"} size="sm" className="national-table" borderRight="1px solid black">
        <Thead className='national-thead'>
            <Tr color="#4149BE" fontWeight="bold" textAlign="center" h="35px" className='national-thead-tr1'>
                <Td textAlign="center" p="0">No</Td>
                <Td textAlign="center" p="0">COUNTRY</Td>
                <Td textAlign="center" p="0">Under Age 12</Td>
                <Td textAlign="center" p="0">Age 12 - 25</Td>
                <Td textAlign="center" p="0">Age 26 - 59</Td>
                <Td textAlign="center" p="0">Age 60 Up</Td>
                <Td textAlign="center" p="0">TOTAL</Td>
                <Td textAlign="center" p="0">Female</Td>
                <Td textAlign="center" p="0">Male</Td>
                <Td textAlign="center" p="0">Total Gender</Td>
                <Td textAlign="center" p="0">ស្ថានភាព</Td>
            </Tr>
        </Thead>

        <Tbody>
        {payroll.data?.map((payroll, i) =>  {
            return (
                <>
                {   payroll.employeePayrollResponses.length > 0 && (
                    payroll.employeePayrollResponses?.map((emp, index) => {

                        return (
                        <>
                            <Tr key={index} h="35px">
                                {/* No */}
                                <Td w="30px" py="0" px="2px">
                                    
                                </Td>
                                <Td w="120px" py="0" px="2px">
                                  
                                </Td>
                                <Td w="100px" py="0" p="1">
                                    <Input
                                       padding="2px"
                                       width="100%"
                                       height="30px"
                                       textAlign="center"
                                       id={`payroll-remarks-${emp.employeeId}`}
                                       defaultValue={emp.remarks}
                                       borderColor='gray'          
                                    />
                                </Td>
                                 <Td w="70px" py="0" p="1">
                                    <Input
                                       padding="2px"
                                       width="100%"
                                       height="30px"
                                       textAlign="center"
                                       id={`payroll-remarks-${emp.employeeId}`}
                                       defaultValue={emp.remarks}
                                       borderColor='gray'          
                                    />
                                </Td>
                                 <Td w="70px" py="0" p="1">
                                    <Input
                                       padding="2px"
                                       width="100%"
                                       height="30px"
                                       textAlign="center"
                                       id={`payroll-remarks-${emp.employeeId}`}
                                       defaultValue={emp.remarks}
                                       borderColor='gray'          
                                    />
                                </Td>
                                 <Td w="70px" py="0" p="1">
                                    <Input
                                       padding="2px"
                                       width="100%"
                                       height="30px"
                                       textAlign="center"
                                       id={`payroll-remarks-${emp.employeeId}`}
                                       defaultValue={emp.remarks}
                                       borderColor='gray'          
                                    />
                                </Td>
                                <Td w="60px" py="0" px="2px" bgColor='#DDEBF7'>
                                   
                                </Td>
                                 <Td w="70px" py="0" p="1">
                                    <Input
                                       padding="2px"
                                       width="100%"
                                       height="30px"
                                       textAlign="center"
                                       id={`payroll-remarks-${emp.employeeId}`}
                                       defaultValue={emp.remarks}
                                       borderColor='gray'          
                                    />
                                </Td>
                                 <Td w="70px" py="0" p="1">
                                    <Input
                                       padding="2px"
                                       width="100%"
                                       height="30px"
                                       textAlign="center"
                                       id={`payroll-remarks-${emp.employeeId}`}
                                       defaultValue={emp.remarks}
                                       borderColor='gray'          
                                    />
                                </Td>
                                <Td w="60px" py="0" px="2px" bgColor='#E2EFDA'>
                                   
                                </Td>
                              
               
                                {/* Save button */}
                                <Td w="40px" py="0" px="2px">
                                    <Flex justifyContent='center'>
                                        <Button
                                            className={ emp.status === 1 ?  "ut-button-success" : "ut-button-dark" }
                                            w="20"
                                            h="30px"
                                            id={`ut-button-${emp.id}`}
                                            onClick={() => onPayrollSave([payroll.employeePayrollResponses[index]])}
                                            hidden={!isAllowAdd}                        //condition when submitted or verify or approved can't save
                                            isDisabled={ payrollApprovals?.isSubmitted === 1 || payrollApprovals?.isApproved === 2 || payrollApprovals?.isVerified === 2 }
                                        >
                                            {emp.status === 1  ? "Save" : "Saved"}
                                        </Button>
                                        <Tooltip hasArrow label='Revert' color='black' bg="gray.300">
                                            <IconButton
                                                onClick={() => {
                                                    onDeleteModalOpen();
                                                    setSelected(emp.id);
                                                }}
                                                hidden={!isAllowRevert}                   //condition when submitted or verify or approved can't revert
                                                isDisabled={ payrollApprovals?.isSubmitted === 1 || payrollApprovals?.isApproved===2 || payrollApprovals?.isVerified===2}
                                                className={emp.status === 1 && "is-disable"}
                                                variant="ghost"
                                                colorScheme="red"
                                                size="sm"
                                                id={`del-button-${emp.id}`}
                                                icon={<TiDelete size="1.7rem" />}
                                            />
                                        </Tooltip>
                                    </Flex>
                                </Td>
                             
                            </Tr>
                        </>    
                        )
                    })
                )}
            </>
            )
        })}
        <Tr h="35px" background="#C8C8C8" color="#4149BE" fontWeight="bold">
            <Td p="0" style={{backgroundColor: "#C8C8C8", color: 'black'}}></Td>
            <Td p="0" style={{backgroundColor: "#C8C8C8", color: 'black'}} textAlign="center">Total</Td>
            <Td py="0" style={{backgroundColor: "#C8C8C8", color: 'black'}} px="2"></Td>
            <Td w="90px" textAlign="right" p="0"></Td>
            <Td w="90px" textAlign="right" p="0"></Td>
            <Td w="90px" textAlign="right" p="0"></Td>
            <Td w="90px" textAlign="right" p="0"></Td>
            <Td w="90px" textAlign="right" p="0"></Td>
            <Td w="90px" textAlign="right" p="0"></Td>
            <Td w="90px" textAlign="right" p="0"></Td>
            <Td p="0" textAlign="right">
				{/* <span id="total-currentSalary"/> */}
            </Td>
            
        </Tr>
        </Tbody>
    </Table>
    </>
  )
}

export default NationalTouristTable
